// extracted by mini-css-extract-plugin
export default {"socialContainer":"social_socialContainer__rB+a8","socialsection":"social_socialsection__JI06d"};